import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LaborState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: LaborState = {
  data: [],
  isLoading: false,
  error: null,
};

const laborSlice = createSlice({
  name: 'labors',
  initialState,
  reducers: {
    setLabors: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setLaborLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setLaborError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setLabors, setLaborLoading, setLaborError } = laborSlice.actions;

export default laborSlice.reducer;
